var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('UiAlert',{attrs:{"type":"warning","icon":"common/timer","button-text":_vm.$tc('notificationPanel.limitsGo'),"text":_vm.alertText,"align-center":_vm.full,"full-size":_vm.full,"is-button":""},on:{"button":_vm.goToLimits}})}
var staticRenderFns = []

export { render, staticRenderFns }